import React from "react";
import { Modal } from "react-bootstrap";
import styled from "styled-components";
import { Link } from "react-router-dom";

import { CategoryApiResponse } from "../../../api/categoryApi";
import { SubCategoryApiResponse } from "../../../api/subCategoryApi";
import { getScreenWidth } from "../../../constants";

const CategoryBlock = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const SubCategoryBlock = styled.ul`
  list-style: none;
`;

const CategoryItem = styled.li`
  margin-top: 10px;

  &:hover {
    background-color: #c0bdb5;
  }
`;

const SubCategoryItem = styled.li`
  padding: 5px;
  margin-top: 5px;

  &:hover {
    background-color: #d4d1c9;
  }
`;

const MenuRow = styled.a`
  text-decoration: none;
  color: black;
  display: block;
`;

const linkTextStyle = {
  textDecoration: "underline",
  color: "#5271FF",
};

const SideModal = ({
  categories,
  subCategories,
  activeCategory,
  closeModal,
}: {
  categories: CategoryApiResponse[];
  subCategories: SubCategoryApiResponse[];
  activeCategory: Record<string, boolean>;
  closeModal: () => void;
}) => {
  const { isTwoColumn } = getScreenWidth();

  return (
    <>
      <Modal.Body>
        <CategoryBlock>
          {categories
            .sort((a, b) => (a.orderIndex || Infinity) - (b.orderIndex || Infinity))
            .map((category) => (
              <React.Fragment key={category.id}>
                <CategoryItem
                  className="fw-bold p-1"
                  style={activeCategory[category.id] ? { backgroundColor: category.bgColor } : {}}
                >
                  <MenuRow href={"#" + category.id} onClick={closeModal}>
                    <img
                      src={category.icon}
                      alt={category.categoryName}
                      width={20}
                      className="me-1"
                    />
                    {category.categoryName}
                  </MenuRow>
                </CategoryItem>
                <SubCategoryBlock>
                  {subCategories
                    .filter(({ categoryId }) => categoryId === category.id)
                    .sort((a, b) => (a.orderIndex || Infinity) - (b.orderIndex || Infinity))
                    .map((subCategory) => (
                      <SubCategoryItem key={subCategory.id}>
                        <MenuRow href={"#" + subCategory.id} onClick={closeModal}>
                          <img
                            src={subCategory.icon}
                            alt={subCategory.subCategoryName}
                            width={20}
                            className="me-1"
                          />
                          {subCategory.subCategoryName}
                        </MenuRow>
                      </SubCategoryItem>
                    ))}
                </SubCategoryBlock>
              </React.Fragment>
            ))}
        </CategoryBlock>
        {!isTwoColumn && (
          <div style={{ padding: "10px", position: "absolute", bottom: "10px" }}>
            <div className="mb-2">
              <Link to="/lp" style={linkTextStyle}>
                本サービスについて
              </Link>
            </div>
            <div className="mb-2">
              <Link to="/contact" style={linkTextStyle}>
                お問い合わせ
              </Link>
            </div>
          </div>
        )}
      </Modal.Body>
    </>
  );
};

export default SideModal;
